import React, { useEffect } from 'react';
import { GoogleReCaptchaProvider, useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import PropTypes from 'prop-types';
const { string } = PropTypes;
import { MyPreferenceCenter } from './MyPreferenceCenter';
import { setupAnalytics } from './analytics/common';
import { isB2bUser, isLoggedIn, isNewB2cLink } from './utils/general';
import { setRecaptchaTokenGenerator } from './common/sharedFunctions';
import { setupHelmet } from './analytics/metaData';

function Component({ recaptchaV3Key }) {

  useEffect(() => {
    window.LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('myPreferenceCenter.static.page-load', {
      pageName: 'My Preference Center',
      pageType: 'content',
      primaryCategory: 'My Preference Center',
      subCategory1: 'My Preference Center',
      subCategory2: 'My Preference Center'
    });
  });

  setupHelmet();
  // eslint-disable-next-line react-hooks/rules-of-hooks
  setRecaptchaTokenGenerator(useGoogleReCaptcha());

  return (
    <>
      <MyPreferenceCenter />
    </>
  );
}

Component.propTypes = {
  recaptchaV3Key: PropTypes.string.isRequired
};

export const MyPreferenceCenterHOC = ({ recaptchaV3Key }) => {

  function setup() {
    setupAnalytics();
    if (isLoggedIn()) {
      if (isNewB2cLink() || isB2bUser()) {
        window.location.replace('/myaccount/preferences');
      } else if (isLoggedIn()) {
        window.location.replace('/account/view/emailsubscription');
      }
    }
  }

  useEffect(setup, []);

  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={recaptchaV3Key}
      useEnterprise
      scriptProps={{
        async: false,
        defer: false,
      }}
    >
      <Component recaptchaV3Key={recaptchaV3Key} />
    </GoogleReCaptchaProvider>
  );
};

MyPreferenceCenterHOC.propTypes = {
  recaptchaV3Key: string
};

MyPreferenceCenterHOC.defaultProps = {
  recaptchaV3Key: '',
};
